const AODPrevDocSvg = () => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5506_2947)">
        <path
          d="M13.5024 11.0324L11.1981 8.72818C11.6171 7.89027 11.8964 6.91272 11.8964 5.93516C11.8964 2.65337 9.24302 0 5.96123 0C2.67943 0 0.026062 2.65337 0.026062 5.93516C0.026062 9.21696 2.67943 11.8703 5.96123 11.8703C6.93878 11.8703 7.91634 11.591 8.75424 11.1721L11.0585 13.4763C11.7567 14.1746 12.8041 14.1746 13.5024 13.4763C14.1308 12.7781 14.1308 11.7307 13.5024 11.0324ZM5.96123 10.4738C3.44751 10.4738 1.42257 8.44888 1.42257 5.93516C1.42257 3.42145 3.44751 1.39651 5.96123 1.39651C8.47494 1.39651 10.4999 3.42145 10.4999 5.93516C10.4999 8.44888 8.47494 10.4738 5.96123 10.4738Z"
          fill="#001949"
        />
      </g>
      <defs>
        <clipPath id="clip0_5506_2947">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AODPrevDocSvg;
